import { matchPath } from "react-router-dom";

export const STATIC_SITE_ROUTES = [
  {
    path: "/",
    title: "Authentic Rudraksha Beads Online",
    description:
      "Shop authentic Rudraksha beads, malas, and sacred accessories from Subrahmanya Rudraksha with a fast, secure, and trusted shopping experience.",
    keywords: [
      "authentic rudraksha",
      "rudraksha online",
      "rudraksha mala",
      "subrahmanya rudraksha",
    ],
    priority: 1,
  },
  {
    path: "/product",
    title: "Rudraksha Products and Collections",
    description:
      "Explore curated Rudraksha products, beads, malas, and spiritual items with clean category navigation and fast product discovery.",
    keywords: ["rudraksha products", "rudraksha collection", "beads online"],
    priority: 0.95,
  },
  {
    path: "/product/:categoryId",
    title: "Rudraksha Category Listings",
    description:
      "Browse authentic Rudraksha products by category with optimized filtering, fast browsing, and SEO-friendly catalog pages.",
    keywords: ["rudraksha category", "rudraksha beads category"],
    priority: 0.9,
  },
  {
    path: "/product/:categoryId/:subCategoryId",
    title: "Rudraksha Subcategory Listings",
    description:
      "Explore refined Rudraksha collections by subcategory with a focused shopping experience and strong product discovery.",
    keywords: ["rudraksha subcategory", "rudraksha collection"],
    priority: 0.88,
  },
  {
    path: "/product/:categoryId/:subCategoryId/:id",
    title: "Rudraksha Product Detail",
    description:
      "View detailed Rudraksha specifications, pricing, variants, and availability for each sacred product.",
    keywords: ["rudraksha product detail", "rudraksha beads price"],
    priority: 0.85,
  },
  {
    path: "/about",
    title: "About Subrahmanya Rudraksha",
    description:
      "Learn how Subrahmanya Rudraksha sources authentic, lab-tested Rudraksha beads with a focus on trust, quality, and spiritual relevance.",
    keywords: ["about rudraksha", "authentic rudraksha source"],
    priority: 0.8,
  },
  {
    path: "/contact",
    title: "Contact Subrahmanya Rudraksha",
    description:
      "Contact the Subrahmanya Rudraksha team for product guidance, custom requests, order support, and spiritual consultation.",
    keywords: ["rudraksha contact", "rudraksha support"],
    priority: 0.75,
  },
  {
    path: "/find-your-rudraksha",
    title: "Find Your Rudraksha",
    description:
      "Use the Rudraksha quiz to discover the most suitable beads based on your needs, goals, and spiritual preferences.",
    keywords: ["rudraksha quiz", "find your rudraksha"],
    priority: 0.82,
  },
  {
    path: "/custom-studio",
    title: "Custom Rudraksha Studio",
    description:
      "Create a custom Rudraksha combination tailored to your requirements with guided product selection and support.",
    keywords: ["custom rudraksha", "rudraksha studio"],
    priority: 0.78,
  },
  {
    path: "/rudraksha",
    title: "Rudraksha",
    description:
      "Explore Find Your Rudraksha, the collection filters, authenticity proof, and the learning center in one accessible guide.",
    keywords: ["rudraksha guide", "find your rudraksha", "rudraksha authenticity"],
    priority: 0.7,
  },
  {
    path: "/privacy-policy",
    title: "Privacy Policy",
    description:
      "Read the privacy policy for Subrahmanya Rudraksha, including how personal data is collected, used, and protected.",
    priority: 0.4,
  },
  {
    path: "/terms-of-use",
    title: "Terms of Use",
    description:
      "Review the terms of use, transaction rules, and legal conditions for using the Subrahmanya Rudraksha website.",
    priority: 0.4,
  },
  {
    path: "/login",
    title: "Login",
    description: "Access your Subrahmanya Rudraksha account.",
    noIndex: true,
  },
  {
    path: "/register",
    title: "Register",
    description: "Create a Subrahmanya Rudraksha account.",
    noIndex: true,
  },
  {
    path: "/forgot-password",
    title: "Forgot Password",
    description: "Reset your Subrahmanya Rudraksha account password.",
    noIndex: true,
  },
];

export const NON_INDEXABLE_PATTERNS = [
  "/cart",
  "/cart/checkout",
  "/my-account/*",
  "/wishlist",
  "/result",
  "/admin/*",
];

export const SITEMAP_PATHS = [
  "/",
  "/product",
  "/about",
  "/contact",
  "/find-your-rudraksha",
  "/custom-studio",
  "/rudraksha",
  "/privacy-policy",
  "/terms-of-use",
];

export const getRouteSeoByPath = (pathname = "/") => {
  const exactMatch = STATIC_SITE_ROUTES.find((route) => {
    const matched = matchPath({ path: route.path, end: true }, pathname);
    return Boolean(matched);
  });

  if (exactMatch) return exactMatch;

  if (matchPath({ path: "/admin/*", end: false }, pathname)) {
    return {
      path: pathname,
      title: "Admin Panel",
      description: "Administrative area for managing the Subrahmanya Rudraksha store.",
      noIndex: true,
      noFollow: true,
    };
  }

  if (matchPath({ path: "/my-account/*", end: false }, pathname)) {
    return {
      path: pathname,
      title: "My Account",
      description: "Manage your Subrahmanya Rudraksha account, profile, and order history.",
      noIndex: true,
      noFollow: true,
    };
  }

  return {
    path: pathname,
    title: "Subrahmanya Rudraksha",
    description:
      "Authentic Rudraksha beads, malas, and spiritual guidance from Subrahmanya Rudraksha.",
  };
};
